import styled from 'styled-components'

export const DeliveryContainer = styled.div`
  margin-top: 40px;
`
